/**
 * @module custom
 * @description 历史项目定制通用函数
 * @author: Yawei Wang
 * @date: 2019-06-03 11:00:26
 */
import { utils } from '../index';
/**
 * 获取id 方法
 * @function
 */

export var getId = function getId() {
  return window.location.pathname.match(/\d+/g);
};
/**
 * 获取uuid方法
 * @function
 */

export var getUuid = function getUuid() {
  return window.location.pathname.match(/[0-9a-f]{16,16}/g);
};
/**
 * 添加事件
 * @function
 * @param {Object} obj 被添加事件的对象
 * @param {String} xEvent  事件名称
 * @param {Function} fn 事件执行函数
 */

export var addEvent = function addEvent(obj, xEvent, fn) {
  if (obj.attachEvent) {
    obj.attachEvent('on' + xEvent, fn);
  } else {
    obj.addEventListener(xEvent, fn, false);
  }
};
/**
 * 移除事件
 * @function
 * @param {*} obj
 * @param {*} xEvent
 * @param {*} fn
 */

export var removeEvent = function removeEvent(obj, xEvent, fn) {
  if (obj.detachEvent) {
    obj.detachEvent('on' + xEvent, fn);
  } else {
    obj.removeEventListener(xEvent, fn, false);
  }
};
/**
 * 注销事件
 * @function
 * @param {*} obj
 * @param {*} xEvent
 */

export var offEvent = function offEvent(obj, xEvent) {
  obj.removeEventListener(xEvent);
};
/**
 * 获取主站链接
 * @function
 */

export var getHost = function getHost() {
  return utils.getSitePreUrl('www');
};